module.exports = __webpack_public_path__ + "img/image7.7f27347f.png";